var styles = {"button":"styles_button__B3-Rm","roundButton":"styles_round-button__uToXJ","children":"styles_children__tT-sN"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
